export default {
   messages_templates_tab_id: 'Id',
   messages_templates_template: 'Template',
   messages_templates_language: 'Language',
   messages_templates_email_from: 'Email From',
   messages_templates_email_body: 'Email Body',
   messages_templates_add_message_template: 'Add Message Template',
   messages_templates_edit: 'Edit',
   messages_templates_tab_templates_title: 'Message Templates',
   messages_templates_email_subject: 'Email Subject',
   messages_templates_delete: 'Delete',
   messages_templates_name: 'Name',
   messages_templates_username: 'Username',
   messages_templates_link: 'Link',
   messages_templates_code: 'Code',
   messages_templates_template_fields: 'Template Fields',

   messages_templates_tab_status: 'Status',
   messages_templates_tab_companies: 'Companies',
   messages_templates_tab_accounts: 'Accounts',
   messages_templates_tab_advanced_filters: 'Advanced Filters',
   messages_templates_tab_apply: 'Apply',
   messages_templates_tab_tags: 'Tags',
   messages_templates_tab_active_accounts_only: 'Active Accounts Only',
   messages_templates_tab_yes: 'Yes',
   messages_templates_tab_no: 'No',
   messages_templates_tab_authenticate_cloud: 'Login as Customer',
   messages_templates_tab_re_sync_backend_information: 'Re-sync Backend Information',
   messages_templates_tab_devices: 'Devices',
   messages_templates_tab_package: 'Package',
   messages_templates_tab_crm: 'Salesforce Id',
   messages_templates_tab_add_account: 'Add Account',
   messages_templates_tab_edit: 'Edit',
   messages_templates_tab_remove_filters: 'Remove filters',
   messages_templates_tab_account_details: 'Account Details',
   messages_templates_tab_import_from_p4: 'Import From P4',
   messages_templates_tab_reprocess_odo_hours: 'Reprocess Odo/Hrs',
   messages_templates_tab_new_status: 'New Status',
   messages_templates_tab_at: 'at',
   messages_templates_tab_next_scheduled_action: 'Next scheduled action on',
   messages_templates_tab_on: 'on'
};



